// Components
import { useEffect } from "react";
import DialogMenu from "./DialogMenu.jsx";

// Stores
import useApplicationSettings from "../../Store/ApplicationSettings.js";

export default function DialogMenuProvider(props) {
  const dialogMenuContent = useApplicationSettings(
    (state) => state.dialogMenuContent
  );

  let elements = dialogMenuContent.map((element, index) => {
    return (
      <DialogMenu
        needCloseButton={element.needCloseButton}
        props={element.props}
        name={element.name}
        hide={element.hide}
        page={element.value}
      />
    );
  });

  useEffect(() => {
    elements = dialogMenuContent.map((element, index) => {
      return (
        <DialogMenu
          needCloseButton={element.needCloseButton}
          props={element.props}
          name={element.name}
          hide={element.hide}
          page={element.value}
        />
      );
    });
  }, [dialogMenuContent]);

  return <>{elements}</>;
}
